import { render, staticRenderFns } from "./MspForsageCompany.vue?vue&type=template&id=f2af8e60&scoped=true"
import script from "./MspForsageCompany.vue?vue&type=script&lang=js"
export * from "./MspForsageCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af8e60",
  null
  
)

export default component.exports